
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseRate } from '../_models/baseRateItem';
import { BillingChoiceData } from '../_models/BillingChoiceData';
import { BillRateItem } from '../_models/billRateItem';
import { AuthHeader } from './../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  aHeader = undefined
  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService
    ) { this.aHeader = new AuthHeader(tss) }

    getSubscriptionChoices(country:any){
     let billingInfo = country['billing_info']
     let items =[]
     let w:BillingChoiceData = new BillingChoiceData()
     w.name="week"
     w.currency=billingInfo['currency']
     w.amount=billingInfo['week']
    items.push(w)
    let m:BillingChoiceData = new BillingChoiceData()
    m.name="month"
    m.currency=billingInfo['currency']
    m.amount=billingInfo['month']
    items.push(m)
    let y:BillingChoiceData = new BillingChoiceData()

y.name="year"
y.currency=billingInfo['currency']
y.amount=billingInfo['year']
items.push(y)
return items
    }
    getSettlementChoice(billingInfo:any, choice:string){
      let w:BillingChoiceData = new BillingChoiceData()

      if( choice=="week"){
        w.amount=billingInfo['week']
        w.name="week"
      }else if( choice=="month"){
        w.amount=billingInfo['month']
        w.name="month"
      }else{
        w.amount=billingInfo['year']
        w.name="year"
      }
      w.currency=billingInfo['currency']
      w.billingChartId=billingInfo['server_billing_chart_id']
     return w
     }

  getBillingInfo(){

    return this.http.get<any>(`${environment.apiUrl}/billingChart/apiinfo`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }
        return []
      }
    ));
  }

  getBaseRate(id:number){

    return this.http.get<any>(`${environment.apiUrl}/billingChart/getBaseRate/${id}`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }
        return new BaseRate()
      }
    ));
  }

  updateBaseRate(baseRate:BaseRate){

    return this.http.post(`${environment.apiUrl}/billingChart/updateBaseRate`, baseRate.formData(), this.aHeader.bearerFormHeaders)
    .pipe(map(
      sInfo => {
      if(this.dataUtilService.isGoodResponse(sInfo)){
        return  sInfo
      }
      return {}
    }));
  }
  getBillingIndex(){

    return this.http.get<any>(`${environment.apiUrl}/billingChart/apiindex`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }
        return []
      }
    ));
  }

  getBillingChartById(id:number){
    return this.http.get<any>(`${environment.apiUrl}/billingChart/apibyid/${id}`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }
        return []
      }
    ));
  }
  update(billingRateItem: BillRateItem) {
    return this.http.post(`${environment.apiUrl}/billingChart/apiupdate`, billingRateItem.formData(), this.aHeader.bearerFormHeaders)
      .pipe(map(
        sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
          return  sInfo
        }
        return {}
      }));
  }
}
